import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTIENER WAREHOUSES
export const getWarehouses = async () => {
    const result = await PrivateInterceptor('Warehouses', 'GET')
    return result;
};
